import Vue from "vue";
import Router from "vue-router";

//Admin
import Admin from "./admin/Admin";

//Client
import Home from "./client/pages/Home";
import About from "./client/pages/About.vue";
import Pricing from "./client/pages/Pricing.vue";
import Gallery from "./client/pages/Gallery.vue";
import Contact from "./client/pages/Contact";
import Work from "./client/pages/Work";

import Login from "./client/pages/Login";
import Registration from "./client/pages/Registration";

Vue.use(Router);

const router=new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: Home,
      name: "Home",
    },
    {
      path: "/o-firmie/",
      component: About,
      name: "About",
    },
    {
      path: "/oferta/",
      component: Pricing,
      name: "Pricing",
    },
    {
      path: "/galeria/",
      component: Gallery,
      name: "Gallery",
    },
    {
      path: "/praca/",
      component: Work,
      name: "Work",
    },
    {
      path: "/kontakt/",
      component: Contact,
      name: "Contact",
    },
    //Auth, and backend
    {
      path: "/login",
      component: Login,
      name: "Login",
      meta: {
        layout: "login",
      },
    },
    {
      path: "/registration",
      component: Registration,
      name: "Registration",
    },
    {
      path: "/api",
    },
    {
      path: "/admin",
      name: "Admin",
      component: Admin,
      meta: {
        layout: "dashboard",
        requiresAuth: true,
      },
    },
  ],
  scrollBehavior() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  },
});

export default router;

